<template>
  <IconLucideWifiOff />
</template>
